const API_AUTH_USERNAME = "microlift";
const API_AUTH_PASSWORD = "jdnetB31eW3K8od";
const API_BASE_URL = "https://microdynamicsoftware.uk/lift/";
export { API_AUTH_USERNAME, API_AUTH_PASSWORD, API_BASE_URL };
